import type { MoneyDirection } from '../transactionFilterTypes';

const getSearchAmounts = (
    minAmount: number | undefined,
    maxAmount: number | undefined,
    moneyDirection: MoneyDirection | undefined,
) => {
    if ((minAmount === undefined && maxAmount === undefined) || moneyDirection === undefined) {
        return {};
    }

    if (moneyDirection === 'sent') {
        return { minAmount: maxAmount && maxAmount * -1, maxAmount: (minAmount && minAmount * -1) || 0 };
    }

    return {
        minAmount: minAmount || 0,
        maxAmount,
    };
};

export default getSearchAmounts;
